export default "__VITE_ASSET__ea8c9728__"